import React, { memo } from 'react';
import { useMarqueeAnimation } from '../../hooks/useAnimations';

interface MarqueeProps {
  children: React.ReactNode;
  speed?: 'slow' | 'normal' | 'fast';
  className?: string;
  expandOnHover?: boolean; // Control whether to add extra padding for hover expansions
}

const MarqueeComponent: React.FC<MarqueeProps> = ({ 
  children, 
  speed = 'normal',
  className = '',
  expandOnHover = true
}) => {
  const { marqueeRef, containerClasses } = useMarqueeAnimation();

  const speedClass = {
    slow: 'animate-marquee-scroll',
    normal: 'animate-marquee-scroll', 
    fast: 'animate-marquee-scroll'
  }[speed];

  // Enhanced container classes with expansion support
  // py-8 provides enough space for 1.05x scale transformations
  const enhancedContainerClasses = `${containerClasses} ${className} ${
    expandOnHover ? 'py-8' : ''
  }`;

  return (
    <div 
      ref={marqueeRef} 
      className={enhancedContainerClasses}
    >
      <div 
        className={`flex ${speedClass} will-change-transform transform-gpu`}
        style={{
          width: 'max-content',
          transform: 'translateZ(0)',
          backfaceVisibility: 'hidden',
          perspective: '1000px'
        }}
      >
        {/* First set */}
        <div className="flex" style={{ minWidth: 'max-content' }}>
          {children}
        </div>
        {/* Duplicate for seamless scrolling */}
        <div className="flex" style={{ minWidth: 'max-content' }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export const Marquee = memo(MarqueeComponent);
